<template>
  <div>
    <div ref="div1" class="div">
      <div :id="randomid1" class="toolbar" style="width:850px;"></div>
      <p>------ 我是分割线 ------</p>
      <div class="textContainer">
      <div :id="randomid2" class="text" style="width:850px;height:800px;overflow:hidden"></div>

      </div>
    </div>
    <shade v-if="showResourceStore > 0">
      <resource-store :shadeShow="showResourceStore > 0" @onClick="onResourceStoreCallback" :appID="appid">
      </resource-store>
    </shade>
  </div>
</template>
<script>
  import E from 'wangeditor'
  const {
    $,
    BtnMenu,
    DropListMenu,
    PanelMenu,
    DropList,
    Panel,
    Tooltip
  } = E
  import ResourceStore from "@/components/resourceStore/resourceStore";
  import shade from "@/components/shade/shade";
  // 第一，菜单 class ，Button 菜单继承 BtnMenu class
  class AlertMenu extends BtnMenu {
    // 格式刷状态，未激活状态1，激活状态2，复制完选区状态1
    myBrusthStatus=1
    copyElementDom=null
    constructor(editor) {
      // data-title属性表示当鼠标悬停在该按钮上时提示该按钮的功能简述
      const $elem = E.$(
        `<div class="w-e-menu" data-title="预览">
                <button class="exportbtn">预览</button>
            </div>
            <div class="w-e-menu" data-title="格式刷" style='width:50px'>
                <button class="formateBrusth">格式刷r</button>
            </div>
            `
      )
      super($elem, editor)
      this.myeditor = editor
    }
    set brusthStatus(value){
      let btn=document.querySelector('.formateBrusth')
      let str=''
      switch (value) {
        case 1:
          str='格式刷r'
          break;
        case 2:
          str='格式刷s'
          break;
        default:
          break;
      }
      btn.innerHTML=str
      this.myBrusthStatus=value
    }
    get brusthStatus(){
      return this.myBrusthStatus
    }
    // 获取选区
    getSelectArea(selection){
      let selectArea=selection._currentRange.commonAncestorContainer
      let endOffset=selection._currentRange.endOffset
      let startOffset=selection._currentRange.startOffset
      // console.log(this.editor.getFragment())
      if(selectArea.nodeType==3){
        if(startOffset==endOffset){
          return 
        }
      }else{
        // 选到最初节点
        if(selectArea.classList.contains('w-e-text')){
          return 
        }
      }
      return selection._currentRange
      // console.log(typeof selectArea)
    }
    copyDom(dom){
      this.copyElementDom=dom
    }
    changeDom(copyDOM,SETDOM){
      console.log(copyDOM,SETDOM)
      console.log(SETDOM.commonAncestorContainer.parentNode)
      let endOffset=SETDOM.endOffset
      let startOffset=SETDOM.startOffset
      if(SETDOM.commonAncestorContainer.nodeType==3){
        if(startOffset==endOffset){
          return 
        }
        let r=SETDOM.commonAncestorContainer.parentNode.innerText
        let cloneNode=copyDOM.commonAncestorContainer.cloneNode()
        if(copyDOM.commonAncestorContainer.nodeType==3){
          cloneNode=copyDOM.commonAncestorContainer.parentNode.cloneNode()
        }
        console.log(copyDOM)
        SETDOM.commonAncestorContainer.parentNode.appendChild(cloneNode)
        cloneNode.innerText=r.slice(startOffset,endOffset)
        // SETDOM.commonAncestorContainer.parentNode.innerText=r
        console.log(r)
        console.log(cloneNode)
      }
    }
    findDomP(dom){
      if(dom.tagName=='p'){
        return dom
      }
      return this.findDomP(dom.parentNode)
    }
    setDomHtml(dom){

    }
    // 菜单点击事件
    clickHandler(e) {
      // 做任何你想做的事情
      // 可参考【常用 API】文档，来操作编辑器
      // 预览功能
      if(e.srcElement.classList.contains('exportbtn')){
          this.myeditor.myexporthtml(1)
      }
      // 格式刷功能
      if(e.srcElement.classList.contains('formateBrusth')){
          // this.myeditor.myexporthtml(1)
          // 首先查找选区
          if(this.brusthStatus==1){
            this.copyElementDom=null
            let dom=this.getSelectArea(this.editor.selection)
            this.brusthStatus=2
            this.copyDom(dom)
            return 
          }
          // 先查找选区
          if(this.brusthStatus==2){
            let dom=this.getSelectArea(this.editor.selection)
            this.changeDom(this.copyElementDom,dom)
            this.brusthStatus=1
          }
      }
      
    }
    // 菜单是否被激活（如果不需要，这个函数可以空着）
    // 1. 激活是什么？光标放在一段加粗、下划线的文本时，菜单栏里的 B 和 U 被激活，如下图
    // 2. 什么时候执行这个函数？每次编辑器区域的选区变化（如鼠标操作、键盘操作等），都会触发各个菜单的 tryChangeActive 函数，重新计算菜单的激活状态
    tryChangeActive() {
      // 激活菜单
      // 1. 菜单 DOM 节点会增加一个 .w-e-active 的 css class
      // 2. this.this.isActive === true
      this.active()

      // // 取消激活菜单
      // // 1. 菜单 DOM 节点会删掉 .w-e-active
      // // 2. this.this.isActive === false
      // this.unActive()
    }
  }
  export default {
    name: 'wangeditor',
    components: {
      ResourceStore,
      shade
    },
    props: ['init', 'isedit','geteditor'],
    data() {
      return {
        randomid1:'ID'+Math.round(Math.random() * 10000),
        randomid2:'ID'+Math.round(Math.random() * 10000),
        showResourceStore: 0,
        appid: 188,
        editor: null
      }
    },
    watch: {
      isedit: function (n, o) {
        if (this.editor) {
          if (n) {
            this.editor.enable()
          } else {
            this.editor.disable()
          }
        }

      }
    },
    methods: {
      onResourceStoreCallback(e) {
        this.showResourceStore = 0
        this.editor.cmd.do('insertHTML', `<img src="${e.resourceID}" style="max-width:100%;"/>`)
        console.log(e)
      },
      clickimg(e) {},
      exporthtml(f) {
        if(f){
        this.$emit('savereturn', this.editor.txt.html(),f)

        }else{
          this.$emit('savereturn', this.editor.txt.html())
        }
        this.$emit('savereturntxt', this.editor.txt.text())
      },
      appendhtml() {
        let editor = this.editor
        console.log(this.editor)
        return (html) => {
          // 先清空
          editor.txt.clear()
          // 在赋值
          editor.txt.append(html)
        }

      },
      exportappend() {
        // console.log(this.$parent.geteditor)
        if (this.geteditor) {
          this.geteditor(this.appendhtml()).call(this.$parent)
        }
      }
    },
    mounted() {
      const menuKey = 'alertMenuKey'
      // 注册菜单
      E.registerMenu(menuKey, AlertMenu)
      this.editor = new E('#'+this.randomid1, '#'+this.randomid2)
      // 设置编辑区域高度为 500px
      this.editor.myexporthtml = function (f) {
        this.exporthtml(f)
      }.bind(this)
      this.editor.config.onchange = function () {
        this.editor.myexporthtml()
        // console.log("change 之后最新的 html", newHtml);
      }.bind(this)
      this.editor.config.height = 700
      this.editor.config.zIndex = 1
      this.editor.config.colors = ['#0071DC','#FFC220',...this.editor.config.colors]
      
      console.log(this.editor.config.colors)
      this.editor.config.uploadImgFromMedia = () => {
        this.showResourceStore = 1
      }
      this.editor.create()
      if (!this.isedit) {
        this.editor.disable()
      }
      if (this.init.html) {
        this.editor.txt.html(this.init.html)
      }
      this.exportappend()
    },
    beforeDestroy() {
      // 销毁编辑器
      this.editor.destroy()
      this.editor = null
    }
  }
</script>
<style>
.div{
  height: calc(100vh - 250px);
  /* overflow-y: auto; */
  /* position: relative; */
}
.textContainer{
  height: calc(100% - 150px);
  overflow-y: auto;
}
/* .toolbar */
  .toolbar {
    border: 1px solid #ccc;
    /* position: absolute; */
    /* top:0; */
  }

  .text {
    border: 1px solid #ccc;
    min-height: 400px;
  }

  .exportbtn {
    background: #fff;
    border: none;
    cursor: pointer;
  }
  .formateBrusth {
    background: #fff;
    border: none;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/wangeditor/wangeditor.vue